import { render, staticRenderFns } from "./BienDetailsNearbyProperties.vue?vue&type=template&id=6ceb4df0&scoped=true"
import script from "./BienDetailsNearbyProperties.vue?vue&type=script&lang=js"
export * from "./BienDetailsNearbyProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb4df0",
  null
  
)

export default component.exports